import { QueryClient } from '@tanstack/react-query';
import { getToken } from './auth';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // @ts-ignore No idea how to fix this error
      async queryFn({ queryKey: [meta], signal }: QueryFunctionContext<[{ isPublic?: boolean; path: string }]>) {
        if (meta?.path) {
          const query = new URLSearchParams(meta.query).toString();

          return await fetch(`/api/${meta.path}${query && `?${query}`}`, {
            headers: meta.isPublic ? {} : await authHeader(),
            signal,
            cache: meta?.cache || 'default',
          }).then(handleResponse);
        } else {
          throw new Error('Please provide a path as QueryKey');
        }
      },
      retry: false,
      refetchOnWindowFocus: () => false,
    },
  },
});

export const apiPaths = {
  activeSimulations: 'simulations/active',
  activeClassrooms: 'classrooms/active',
  abandon: (sessionId?: string) => `/api/session/${sessionId}/abandon`,
  me: 'me',
  uploadPicture: '/api/user-profile/upload-picture',
  editProfile: '/api/user-profile/edit',
  teach: {
    assessment: (companyId?: string, userId?: string, simulationId?: string, platform?: string | number) =>
      `teach/companies/${companyId}/users/${userId}/simulation/${simulationId}/platform/${platform}/assessment`,
    classroomSimulation: (companyId?: string, exerciseId?: string, simulationId?: string) =>
      `teach/companies/${companyId}/scheduled-exercises/${exerciseId}/simulations/${simulationId}`,
    simulation: (companyId?: string, exerciseId?: string, userId?: string, simulationId?: string) =>
      `teach/companies/${companyId}/scheduled-exercises/${exerciseId}/users/${userId}/simulations/${simulationId}`,
    users: (companyId?: string, exerciseId?: string) =>
      `teach/companies/${companyId}/scheduled-exercises/${exerciseId}/users`,
    user: (companyId?: string, exerciseId?: string, userId?: string) =>
      `teach/companies/${companyId}/scheduled-exercises/${exerciseId}/users/${userId}`,
    exercises: (companyId?: string) => `teach/companies/${companyId}/exercises`,
    exercise: (companyId?: string, exerciseId?: string) =>
      `teach/companies/${companyId}/scheduled-exercises/${exerciseId}`,
    endExercise: (companyId?: string, exerciseId?: string) =>
      `teach/companies/${companyId}/scheduled-exercises/${exerciseId}/end`,
    metadata: (companyId?: string) => `api/teach/companies/${companyId}/scheduled-exercises/metadata`,
  },
  learn: {
    assessment: (companyId?: string, simulationId?: string, platform?: string | number) =>
      `learn/companies/${companyId}/simulation/${simulationId}/platform/${platform}/assessment`,
    simulation: (companyId?: string, exerciseId?: string, simulationId?: string) =>
      `learn/companies/${companyId}/scheduled-exercises/${exerciseId}/simulations/${simulationId}`,
  },
  faulted: (sessionId?: string) => `/api/session/${sessionId}/faulted`,
};

export const handleResponse = (response: Response) => {
  if (!response.ok) {
    throw response;
  }

  return response.headers.get('Content-Type')?.includes('application/json') ? response.json() : response.text();
};

export const authHeader = async () => {
  return { Authorization: `Bearer ${await getToken()}` };
};
